import React, { useState, useRef, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";

const ProductIngredientResult = (props) => {
    let componentData = props.componentData;
    let productIngredientResultData = props.ProductIngredientResultData;
    const [errorResponseText, setErrorResponseText] = useState("");
   
    useEffect(() => {
        setErrorResponseText(productIngredientResultData?.apiData ? productIngredientResultData?.error : "");
    }, [productIngredientResultData]);
   
    return (
         <div className="results-block">
                <div className="text-center">
                    <div className="table-wrapper table-responsive">
                        <table className="table">
                            <thead>
                                <tr>                                    
                                    <th>Ingredients</th>
                                    <th>Purpose</th>
                                </tr>
                            </thead>
                            <tbody>                                
                                {
                                    productIngredientResultData.apiData?.Products?.map((product, productIndex) => (
                                        product.Ingredients.map((ingredient, index) => (
                                            <tr key={`${productIndex}-${index}`}>
                                                <td>{ingredient.IngredientName}</td> {/* Assuming ingredient has a Name property */}
                                                <td>{ingredient.IngredientPurpose}</td> {/* Assuming ingredient has a Purpose property */}
                                            </tr>
                                        ))
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>                 
                </div>
         </div>
    );
};

export default withTranslation()(ProductIngredientResult);